/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Advanced_HintInputs */

const cs_builder_advanced_hint = /** @type {(inputs: Builder_Advanced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ručně upravený Typst je oddělený, dokud znovu nesynchronizujete z vizuálu.`)
};

const en_builder_advanced_hint = /** @type {(inputs: Builder_Advanced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand-edited Typst is forked until you sync from visual again.`)
};

/**
* | output |
* | --- |
* | "Hand-edited Typst is forked until you sync from visual again." |
*
* @param {Builder_Advanced_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_advanced_hint = /** @type {((inputs?: Builder_Advanced_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Advanced_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_advanced_hint(inputs)
	return cs_builder_advanced_hint(inputs)
});